import type { ProductType } from '@components/ProductForm'
import { useOpenable } from '@hooks/base'
import { useMemo } from 'react'

import { ProductModal, type ProductModalContext } from './ProductModal'

const useProductModal = (
	saveNewProduct: (data: ProductType) => Promise<void>,
	context: ProductModalContext,
	onProductBulkImport?: () => void
) => {
	const [isOpen, showProductModal, hide] = useOpenable()
	const productModal = useMemo(
		() => (
			<ProductModal
				context={context}
				isModalOpened={isOpen}
				onClose={hide}
				saveNewProduct={saveNewProduct}
				onProductBulkImport={onProductBulkImport}
				displaySupplierSelection
			/>
		),
		[context, isOpen, hide, saveNewProduct, onProductBulkImport]
	)
	return {
		productModal,
		showProductModal,
	}
}

export default useProductModal
